export default {
  login: "/auth/login",
  verify: "/auth",
  comments: "/comments",
  refreshtoken: "/api/refreshtoken",
  signup: "/auth/register",
  conditions: "/conditions",
  resources: "/contacts/attributes",
  eventResources: "/events/attributes",
  eventAttributes: "/events/possible-attributes",
  contactsAttributes: "/contacts/possible-attributes",
  campaigns: "/campaigns",
  groups: "/groups",
  domains: "/email/domains",
  resendDomains: "/email/resend/domains",
  updateUserInfo: "/accounts",
  audiences: "/audiences",
  addtemplate: "/audiences/add-template",
  createGroup: "/audiences/create",
  updateGroup: "/audiences/update",
  createTemplate: "/templates/create",
  correlateSlack: "/slack/cor",
  getAllTemplates: "/templates",
  getAllPeople: "/contacts",
  searchContactsForTest: "/contacts/search-for-test",
  searchContactsForWebhookTest: "/contacts/search-for-webhook-test",
  contactCreate: "/contacts/create",
  contactDelete: "/contacts/delete/",
  flow: "/workflows",
  startFlow: "/workflows/start",
  deleteFlow: "/workflows/delete",
  slackInstall: "/slack/install",
  syncPosthog: "/contacts/importph",
  deleteMedia: "accounts/delete-media/",
};
